import React from "react";
import {create} from "zustand/react";

export interface AlertDialogModel {
    title?: string;
    description?: string;
    cancelButtonText?: string;
    onPressCancelButton?: () => void;
    confirmButtonText?: string;
    onConfirmButtonClick?: () => void;
    children?: React.ReactNode;
    buttons?: ({isPending, closeDialog}: {
        isPending: boolean,
        closeDialog: () => void,
    }) => React.ReactNode[];
}

export interface DialogState {
    isPending?: boolean;
    dialogModel?: AlertDialogModel;
    showDialog: (model: AlertDialogModel) => void;
    setIsPending: (isPending: boolean) => void;
    closeDialog: () => void;
}

export const useDialogStore = create<DialogState>((set, getState) => ({
    dialogModel: undefined,
    isPending: false,
    showDialog: (model) => {
        set((state) => ({
            ...state,
            dialogModel: model,
            isPending: false,
        }));
    },
    closeDialog: () => {
        set((state) => ({
            ...state,
            dialogModel: undefined,
            isPending: false
        }));
    },
    setIsPending: (isPending) => {
        set((state) => ({
            ...state,
            isPending
        }))
    }
}));
